import axios from "axios";
import { getAdminApiBaseUrl } from "./baseUrl";

const BASE_URL = getAdminApiBaseUrl();

const API = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

API.interceptors.request.use((config) => {
  // ✅ login endpoint এ token লাগবে না
  const isLogin = config.url?.includes("/admin/login");

  if (!isLogin) {
    const token = localStorage.getItem("adminToken");
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default API;